import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
// import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
// import LottieLoader from './LottieLoader';
import { LinearProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        backgroundColor: theme.palette.type === 'dark' ? '#47474780' : 'rgba(255, 255, 255, 0.5)',
    },
}));
const LoadingScreen = props => {
    const classes = useStyles();
    const { open } = props
    return (
        <div>
            {/* <div style={{ opacity: 1, filter: 'blur(10px) brightness(0.9)', position: 'absolute'}} ></div> */}
            <Backdrop className={classes.backdrop} open={open} style={{
                borderRadius: '5px',
                textAlign: 'center',
                lineHeight: 1,
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                // padding: '20px 40px'
                zIndex: 1400,
                flexDirection: 'column',
                gap: 16
            }
            }>
                {/* <LottieLoader stop = {!open} /> */}
                <img src={process.env.PUBLIC_URL + '/images/logo.svg'} alt="Logo" />
                <LinearProgress indeterminate style={{ width: 120 }}/>
            </Backdrop>
        </div>
    );
};

LoadingScreen.propTypes = {
    open: PropTypes.bool.isRequired,
};

export default LoadingScreen;